import { render, staticRenderFns } from "./NotificacionAportes.vue?vue&type=template&id=61b618c0"
import script from "./NotificacionAportes.vue?vue&type=script&lang=ts"
export * from "./NotificacionAportes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports